import React from 'react'
import { Route } from 'react-router-dom'

import Login from '../Auth/Login'
import Forgot from '../Auth/Forgot'
import ResetPassword from '../Auth/ResetPassword'
import Activate from '../Auth/Activate'
import ViewTerm from '../TermsandPolicies/ViewTerm'


export default function AuthStack(){
  const authScreen = [
    { path: '/login', component: <Login/>, exact: false, isShow: true },
    { path: '/forgot', component: <Forgot/>, exact: false, isShow: true },
    { path: '/resetpassword/:hash', component: <ResetPassword/>, exact: false, isShow: true },
    { path: '/view-term', component: <ViewTerm/>, exact: false, isShow: true },
    { path: '/activate/:token', component: <Activate/>, exact: false, isShow: true }
  ]

  const authScreenRender = authScreen.map((item, key) => {
    if(item.isShow){
      return (
        <Route path={item.path} exact={item.exact} key={key}>
          {item.component}
        </Route>
      )
    }else{
      return null
    }
  })

  return(
    <>
      { authScreenRender }
    </>
  )
}
